<template>
    <div>
        <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Add a New Company</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                        <b-field label="Company Name">
                            <b-input
                                class="is-dvodark"
                                type="text"
                                v-model="companyName"
                                placeholder="Enter your company's name"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Company Address">
                            <b-input
                                type="text"
                                v-model="companyAddress"
                                placeholder="Enter your company's buisiness address"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Company Phone Number">
                            <b-input
                                type="tel"
                                v-model="companyPhone"
                                placeholder="Enter your company's primary phone number"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Company Primary Email">  
                            <b-input
                                type="email"
                                v-model="companyEmail"
                                placeholder="Enter your company's primary email"
                                required>
                            </b-input>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="createCompany()">Make Request</b-button>
                    </footer>
                </div>
        </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { companyHandler } from '../graphql/mutations'
export default {
    data(){
    return{
        companyName: null,
        companyAddress: null,
        companyPhone: null,
        companyEmail: null,
        id: this.userId,
        currentDate: new Date()
        }
    },
    props:['userId'],
    methods:{
    async createCompany() {
    const company = {
        name: this.companyName,
        address: this.companyAddress,
        phone_number: this.companyPhone,
        main_contact_email: this.companyEmail,
        landing_percent: 0,
        labor_cost: 0,
        principal_person: this.id,
        date_created: this.currentDate.getFullYear() + "/" + (this.currentDate.getMonth() + 1) + "/" + this.currentDate.getDate(),
        request_type: 'create'
    }
    await API.graphql({
        query: companyHandler,
        variables: {
            input: company
        }
    });
    this.$emit('close');
    }
}}
</script>
